import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { ApiError } from "@/api/errors";
import { ToastProvider, TooltipProvider } from "@/components/ui";

import { MutationErrorToasts } from "./MutationErrorToasts";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        // Never retry client errors (403/404 are answers, not glitches).
        retry: (count, error) => !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}

export function Providers({ children, client }: { children: ReactNode; client: QueryClient }) {
  return (
    <QueryClientProvider client={client}>
      <TooltipProvider>
        <ToastProvider>
          <MutationErrorToasts />
          {children}
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
